/**
 * 模板市场-列表容器
 * @author VenDream
 * @since 18/03/23
 */

import { connect } from 'react-redux';
import StoreTpls from 'components/store-tpls';

import { setActiveTab } from 'actions/store-tabs';
import {
  getStoreTpls,
  clearStoreTpls,
  togglePosterModal,
  getSpecialZoneTpls,
} from 'actions/tpls';
import { clearSubmitFilters, getOrgZoneFilters } from 'actions/store-filters';

const mapStateToProps = (state, ownProps) => {
  const { keywords } = ownProps;
  const { search, userInfo, storeTabs, storeTpls, storeFilters } = state;
  const { openSearchFilters, orgZoneSearchFilters } = storeFilters;
  const { activeIndex, tabs } = storeTabs;
  const tabIndex = tabs.findIndex(n => n.index === activeIndex);
  let category = tabs[tabIndex === -1 ? 0 : tabIndex].name;
  category = ownProps.category || category;

  return {
    user: userInfo,
    keywords: keywords || keywords === '' ? keywords : search.keywords,
    category,
    status: storeTpls.status,
    filters: storeFilters.submitFilters,
    tplids: storeTpls[category],
    showPosterModal: storeTpls.showPosterModal,
    openSearchFilters,
    orgZoneSearchFilters,
  };
};

const mapDispatchToProps = dispatch => ({
  setActiveTab: (index, url) => {
    dispatch(setActiveTab(index));

    // 有url则推到history中
    // url && window.history.pushState({}, null, url);
    return url;
  },
  clearStoreTpls: () => dispatch(clearStoreTpls()),
  clearSubmitFilters: () => dispatch(clearSubmitFilters()),
  togglePosterModal: flag => dispatch(togglePosterModal(flag)),
  getStoreTpls: (category, filters, pageNo, pageSize, hidePayTemplate, type) =>
    dispatch(
      getStoreTpls(category, filters, pageNo, pageSize, hidePayTemplate, type)
    ),
  getSpecialZoneTpls: opts => dispatch(getSpecialZoneTpls(opts)),
  getOrgZoneFilters: orgId => dispatch(getOrgZoneFilters(orgId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreTpls);
